import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  chart: {
    height: 320,
  },
  updateScore: {
    position: 'fixed',
    bottom: 20,
    right: 20,
  },
});

export default useStyles;
